/* Pawvelune theme: cart drawer (Shopify Ajax cart), product form, gallery, sticky buy bar. */
(() => {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = t => String(t ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Money in the store format ---------- */
  function money(cents) {
    const fmt = (window.theme && theme.moneyFormat) || '${{amount}}';
    const n = Number(cents || 0) / 100;
    const fix = (dec, th, d) => { const p = n.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(d); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fix(2, ',', '.'),
      amount_no_decimals: fix(0, ',', '.'),
      amount_with_comma_separator: fix(2, '.', ','),
      amount_no_decimals_with_comma_separator: fix(0, '.', ','),
      amount_with_apostrophe_separator: fix(2, "'", '.'),
      amount_with_space_separator: fix(2, ' ', ',')
    }[k] || fix(2, ',', '.')));
  }

  /* ---------- Dialogs ---------- */
  document.addEventListener('click', e => {
    const closer = e.target.closest('[data-close-dialog]');
    if (closer) { closer.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG') {
      const r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
    if (e.target.closest('[data-size-guide]')) { e.preventDefault(); const s = $('#sizeSheet'); if (s && !s.open) s.showModal(); }
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); }
  });

  /* ---------- Cart ---------- */
  const drawer = $('#CartDrawer');
  const body = $('#CartDrawerBody');
  let busy = false;

  async function getCart() {
    const r = await fetch(theme.routes.cartJs, { headers: { Accept: 'application/json' } });
    return r.json();
  }
  async function changeLine(key, quantity) {
    if (busy) return; busy = true;
    try {
      const r = await fetch(theme.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      /* Line keys change when the bundle discount changes; if a key is old, draw the cart again from the server */
      renderCart(r.ok ? await r.json() : await getCart());
    } finally { busy = false; }
  }
  function updateCount(count) {
    const c = $('#count'); if (!c) return;
    c.textContent = count; c.classList.toggle('zero', count === 0);
    const b = $('#cartBtn'); if (b) b.setAttribute('aria-label', `Open cart, ${count} item${count === 1 ? '' : 's'}`);
  }
  const prot = theme.protection;
  const isProt = item => prot && item.variant_id === prot.id;
  function protectBox(on) {
    if (!prot) return '';
    return `<label class="protect"><input type="checkbox" data-protect${on ? ' checked' : ''}>
      <span><b>${esc(prot.title)} – ${money(prot.price)}</b><small>${esc(prot.text)}</small></span></label>`;
  }
  async function setProtection(on) {
    if (!prot || busy) return;
    busy = true;
    try {
      if (on) await fetch(theme.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: prot.id, quantity: 1 }] }) });
      else await fetch(theme.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: String(prot.id), quantity: 0 }) });
    } finally { busy = false; }
  }
  function renderCart(cart) {
    const protLine = cart.items.find(isProt);
    const items = cart.items.filter(i => !isProt(i));
    const costumes = items.reduce((n, i) => n + i.quantity, 0);
    updateCount(costumes);
    if (!body) return;
    if (!costumes) {
      if (protLine) { setTimeout(() => changeLine(protLine.key, 0)); return; }
      body.innerHTML = `<div class="empty"><h3>Your cart is empty</h3><p class="muted">The Santa suit is one tap away.</p><a class="btn-red" href="/collections/all">Shop the costume</a></div>`;
      return;
    }
    if (protLine && protLine.quantity > 1) { setTimeout(() => changeLine(protLine.key, 1)); return; }
    const lines = items.map(item => {
      const img = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=160` : '';
      const size = item.product_has_only_default_variant ? '' : `<p class="muted m0">Size: ${esc(item.variant_title)}</p>`;
      const was = item.original_line_price > item.final_line_price ? `<del class="muted">${money(item.original_line_price)}</del> ` : '';
      return `<div class="cart-line">
        ${img ? `<img src="${esc(img)}" width="76" height="76" alt="">` : '<span></span>'}
        <div>
          <h3>${esc(item.product_title)}</h3>${size}
          <div class="line-bottom">
            <div class="stepper"><button type="button" data-change="${esc(item.key)}" data-qty="${item.quantity - 1}" aria-label="One less">−</button><span>${item.quantity}</span><button type="button" data-change="${esc(item.key)}" data-qty="${item.quantity + 1}" aria-label="One more">+</button></div>
            <b>${was}${money(item.final_line_price)}</b>
          </div>
          <button type="button" class="remove" data-change="${esc(item.key)}" data-qty="0">Remove</button>
        </div>
      </div>`;
    }).join('');
    const off = theme.bundleOff || [];
    const next = costumes + 1;
    const first = items[0];
    let upsell = '';
    if (next <= 3 && off[next] > 0 && first) {
      const each = first.original_price - off[next];
      const word = next === 2 ? 'a 2nd' : 'a 3rd';
      upsell = `<div class="upsell box box-pink"><span>Add ${word} costume and pay ${money(each)} each. You save ${money(off[next] * next)}.</span><button type="button" data-change="${esc(first.key)}" data-qty="${first.quantity + 1}">Add</button></div>`;
    }
    const savings = cart.total_discount > 0 ? `<div class="saving"><span>Savings</span><span>−${money(cart.total_discount)}</span></div>` : '';
    body.innerHTML = `${lines}${upsell}${protectBox(!!protLine)}
      <div class="totals">
        <div><span>Subtotal</span><span>${money(cart.original_total_price)}</span></div>
        ${savings}
        <div><span>Shipping</span><span>${theme.freeShipping ? 'Free' : 'Calculated at checkout'}</span></div>
        <div class="total"><span>Total</span><span>${money(cart.total_price)}</span></div>
      </div>
      <form action="${esc(theme.routes.cart)}" method="post"><button type="submit" name="checkout" class="btn-red btn-wide">Checkout securely</button></form>
      <p class="center"><button type="button" class="textlink" data-close-dialog>Continue shopping</button></p>`;
  }
  async function openCart() {
    if (!drawer) { location.href = theme.routes.cart; return; }
    if (!drawer.open) drawer.showModal();
    renderCart(await getCart());
  }
  if (body) body.addEventListener('click', e => {
    const b = e.target.closest('[data-change]');
    if (b) changeLine(b.dataset.change, Math.max(0, Number(b.dataset.qty)));
  });
  /* Shipping protection box: in the drawer it redraws the drawer, on the cart page it reloads the page */
  document.addEventListener('change', async e => {
    const box = e.target.closest('[data-protect]');
    if (!box) return;
    box.disabled = true;
    await setProtection(box.checked);
    if (body && body.contains(box)) { box.disabled = false; renderCart(await getCart()); }
    else location.reload();
  });

  /* ---------- Product form ---------- */
  const form = $('#ProductForm');
  if (form) {
    const rows = $$('.size-row', form);
    const hasSizes = rows.length > 0;
    const picks = [null, null, null];
    let qty = 1;
    const unit = Number(form.dataset.unitPrice);
    const prices = String(form.dataset.prices || '').split(',').map(Number);
    const priceFor = q => prices[q - 1] || unit * q;
    const error = $('#sizeError');
    const addPrice = $('#AddPrice');
    const variantInput = $('#VariantId');
    const bar = $('#stickyBuy');
    const addBtn = $('#addBtn');
    const firstImg = $('#slides img');

    const mark = n => $$('button', rows[n]).forEach(b => b.setAttribute('aria-checked', String(b.dataset.variant === String(picks[n]))));
    const setQty = q => {
      qty = q;
      $$('.qty-choice button', form).forEach(b => b.setAttribute('aria-checked', String(Number(b.dataset.qty) === q)));
      if (hasSizes) {
        rows.forEach((row, n) => {
          if (n === 0) return;
          row.hidden = n >= q;
          const wrap = $(`#SizeLabelWrap${n}`); if (wrap) wrap.hidden = n >= q;
          if (n < q && !picks[n] && picks[0]) { picks[n] = picks[0]; mark(n); }
        });
        const l1 = $('#SizeLabel1'); if (l1) l1.textContent = q > 1 ? 'Size for costume 1' : 'Size';
      }
      if (addPrice && unit) addPrice.textContent = money(priceFor(q));
      updateSticky();
    };
    rows.forEach((row, n) => row.addEventListener('click', e => {
      const b = e.target.closest('button[data-variant]');
      if (!b || b.disabled) return;
      picks[n] = b.dataset.variant; mark(n);
      if (n === 0 && variantInput) variantInput.value = b.dataset.variant;
      if (error && picks.slice(0, qty).every(Boolean)) error.hidden = true;
      updateSticky();
    }));
    $$('.qty-choice button', form).forEach(b => b.addEventListener('click', () => setQty(Number(b.dataset.qty))));
    const qParam = Number(new URLSearchParams(location.search).get('qty'));
    if ((qParam === 2 || qParam === 3) && $(`.qty-choice button[data-qty="${qParam}"]`, form)) setQty(qParam);

    form.addEventListener('submit', async e => {
      e.preventDefault();
      let ids;
      if (hasSizes) {
        const need = picks.slice(0, qty);
        const missing = need.findIndex(v => !v);
        if (missing >= 0) {
          if (error) { error.textContent = 'Choose a size first.'; error.hidden = false; }
          rows[missing].scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
          const first = $('button:not([disabled])', rows[missing]); if (first) first.focus({ preventScroll: true });
          return;
        }
        ids = need;
      } else {
        ids = Array(qty).fill(variantInput.value);
      }
      const grouped = {};
      ids.forEach(id => { grouped[id] = (grouped[id] || 0) + 1; });
      const items = Object.entries(grouped).map(([id, quantity]) => ({ id: Number(id), quantity }));
      const btn = $('#addBtn'); btn.disabled = true;
      try {
        const r = await fetch(theme.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const data = await r.json();
        if (!r.ok) {
          if (error) { error.textContent = data.description || data.message || 'This size is not available.'; error.hidden = false; }
          return;
        }
        openCart();
      } finally { btn.disabled = false; }
    });

    /* Sticky buy bar: shows after the visitor scrolls past the main button */
    function updateSticky() {
      if (!bar || bar.hidden) return;
      const chosen = !hasSizes || picks.slice(0, qty).every(Boolean);
      const titles = hasSizes ? picks.slice(0, qty).map((v, n) => { const b = v && $(`button[data-variant="${v}"]`, rows[n]); return b ? b.dataset.title : ''; }).filter(Boolean) : [];
      bar.innerHTML = `${firstImg ? `<img src="${esc(firstImg.currentSrc || firstImg.src)}" width="48" height="48" alt="">` : ''}
        <div class="txt"><b>${money(priceFor(qty))}</b>${titles.length && chosen ? `Size ${esc(titles.join(' + '))}` : esc(document.querySelector('.buy h1')?.textContent || '')}</div>
        <button type="button" class="btn-red" data-sticky-add>${chosen ? 'Add to cart' : 'Choose size'}</button>`;
    }
    function checkSticky() {
      if (!bar || !addBtn) return;
      const show = addBtn.getBoundingClientRect().bottom < 0;
      if (show === !bar.hidden) return;
      bar.hidden = !show; document.body.classList.toggle('has-sticky', show);
      if (show) updateSticky();
    }
    let tick = false;
    addEventListener('scroll', () => { if (tick) return; tick = true; requestAnimationFrame(() => { tick = false; checkSticky(); }); }, { passive: true });
    if (bar) bar.addEventListener('click', e => { if (e.target.closest('[data-sticky-add]')) form.requestSubmit(); });
  }

  /* ---------- Sale countdown (to a fixed end time; hides when the time is over) ---------- */
  $$('.sale-timer[data-ends]').forEach(el => {
    const end = Date.parse(el.dataset.ends);
    const out = $('[data-left]', el);
    if (!end || !out) return;
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
      const s = Math.floor(left / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
      out.textContent = `${d ? d + 'd ' : ''}${pad(h)}:${pad(m)}:${pad(s % 60)}`;
      el.hidden = false;
    };
    const timer = setInterval(tick, 1000);
    tick();
  });

  /* ---------- Gallery ---------- */
  const slides = $('#slides');
  if (slides) {
    const items = $$('.slide', slides);
    const counter = $('#counter');
    const dots = $('#dots');
    if (dots) dots.innerHTML = items.map((_, i) => `<button type="button" data-go="${i}" aria-label="Show photo ${i + 1}"${i === 0 ? ' aria-current="true"' : ''}></button>`).join('');
    let current = 0;
    const show = i => {
      current = i;
      if (counter) counter.textContent = `${i + 1} / ${items.length}`;
      $$('[data-go]').forEach(b => b.toggleAttribute('aria-current', Number(b.dataset.go) === i));
      $$('[data-go][aria-current]').forEach(b => b.setAttribute('aria-current', 'true'));
    };
    show(0);
    slides.addEventListener('scroll', () => { const i = Math.round(slides.scrollLeft / slides.clientWidth); if (i !== current) show(i); }, { passive: true });
    document.addEventListener('click', e => {
      const go = e.target.closest('[data-go]');
      if (go) slides.scrollTo({ left: Number(go.dataset.go) * slides.clientWidth, behavior: reduceMotion() ? 'auto' : 'smooth' });
      const slide = e.target.closest('.slide');
      if (slide && slide.dataset.zoom) {
        const z = $('#zoom'), img = $('#zoomImg');
        img.src = slide.dataset.zoom; img.alt = $('img', slide)?.alt || '';
        z.showModal();
      }
    });
  }
})();
